import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from 'Common/CustomButtons/Button';
import { FormattedMessage } from 'react-intl';

export default class CoAuthor extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        addCoauthor: PropTypes.func.isRequired,
        coauthors: PropTypes.array
    };

    render() {
        const { addCoauthor, coauthors } = this.props;

        return (
            <div className='co-authors-wrapper'>
                <div id="children-pane">
                    {coauthors}
                </div>
                <Button
                    color="success"
                    type="button"
                    onClick={addCoauthor}
                    className="button-add-coauthor"
                >
                    <FormattedMessage id={'button.submission.add_coauthor'} />
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Submission/CoAuthor.jsx